import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute top-5 right-5" }
const _hoisted_3 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_4 = { class: "flex items-start justify-between w-full p-6" }
const _hoisted_5 = { class: "flex items-start flex-row" }
const _hoisted_6 = { class: "mb-1 text-gray-900 font-semibold text-lg" }
const _hoisted_7 = { class: "flex justify-start items-center gap-2 rounded-full border border-gray-200 p-1 inline-flex mr-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "w-full text-left" }
const _hoisted_10 = { class: "text-xs text-gray-600 font-medium pl-6 py-3 border-b border-b-gray-200" }
const _hoisted_11 = { class: "text-xs text-gray-600 font-medium py-3 border-b border-b-gray-200" }
const _hoisted_12 = { class: "text-xs text-gray-600 font-medium pr-6 py-3 border-b border-b-gray-200" }
const _hoisted_13 = { class: "text-gray-900 font-sm font-medium pl-6 py-6 border-b border-b-gray-200" }
const _hoisted_14 = { class: "text-sm text-gray-600 py-6 border-b border-b-gray-200" }
const _hoisted_15 = { class: "flex flex-row gap-3 items-center pr-6 py-6 border-b border-b-gray-200" }
const _hoisted_16 = { class: "bg-gray-200 rounded-full h-[8px] min-w-36 w-full" }
const _hoisted_17 = { class: "text-gray-700 font-sm font-medium" }
const _hoisted_18 = { class: "flex justify-between items-center mt-3 mb-4 px-6" }
const _hoisted_19 = { class: "text-gray-700 text-sm font-medium" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]

import { ref, computed } from "vue";
import FiltersOutOfDateComponent from "@/modules/main/components/FiltersOutOfDateComponent.vue";
import LoadingSpinnerComponent from "@/modules/main/components/LoadingSpinnerComponent.vue";



// Define the prop to accept mappedData
const itemsPerPageStudents = 7;

export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySummaryPerStudentComponent',
  props: {
    mappedSummaryDataPerStudent: {}
  },
  setup(__props: any) {

const props = __props;




const selectedActivity = ref("Last 30 days");
const currentPageStudents = ref(1);
const activeActivity = ref(
  "border border-gray-200 rounded-full text-sm py-2.5 px-5 font-semibold text-gray-700"
);
const inactiveActivity = ref(
  "py-2.5 px-5 border-transparent rounded-full text-sm font-semibold text-gray-500"
);

// Compute total pages based on data length and items per page
const totalPages = computed(() => {
  return Math.ceil(
    props.mappedSummaryDataPerStudent.length / itemsPerPageStudents
  );
});

//   // Compute the data for the current page
const paginatedData = computed(() => {
  const start = (currentPageStudents.value - 1) * itemsPerPageStudents;
  const end = start + itemsPerPageStudents;
  return props.mappedSummaryDataPerStudent.slice(start, end);
});

// // Pagination control methods
function prevPageStudents() {
  if (currentPageStudents.value > 1) {
    currentPageStudents.value--;
  }
}

function nextPageStudents() {
  if (currentPageStudents.value < totalPages.value) {
    currentPageStudents.value++;
  }
}

// Generate progress bar background for activity cards
const generateColoursFromPercentage = (percentage: number) => {
  // Red Color
  if (percentage <= 33) {
    return "bg-red-300";
  }

  // Yellow Color
  if (percentage > 33 && percentage <= 66) {
    return "bg-yellow-400";
  }

  // Green Color
  if (percentage > 66) {
    return "bg-emerald-200";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingSpinnerComponent),
    _createVNode(FiltersOutOfDateComponent),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_3, [
        _createVNode(_component_rl_icon, {
          icon: 'rl-info-circle',
          title: 'rl info circle',
          "aria-hidden": "true"
        })
      ])), [
        [
          _directive_tooltip,
          _ctx.$t('activity_view.tooltips.activity_summary_student'),
          "left",
          { tooltip: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_student_card.header")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedActivity.value = 'Last 30 days')),
          class: _normalizeClass(
            (selectedActivity.value === 'Last 30 days'
              ? activeActivity.value
              : inactiveActivity.value) + ' px-2'
          )
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.last_30_days")), 3),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedActivity.value = 'Last 7 days')),
          class: _normalizeClass(
            (selectedActivity.value === 'Last 7 days'
              ? activeActivity.value
              : inactiveActivity.value) + ' px-2'
          )
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.last_7_days")), 3)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("table", _hoisted_9, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_student_card.student")), 1),
        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.average_minutes")), 1),
        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.daily_tasks")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (data, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", _hoisted_13, _toDisplayString(data.userName), 1),
          _createElementVNode("td", _hoisted_14, _toDisplayString(selectedActivity.value === "Last 30 days"
              ? Math.floor(data.averageLearningTimeMonth / 60)
              : Math.floor(data.averageLearningTimeWeek / 60)) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.min")), 1),
          _createElementVNode("td", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass(
                generateColoursFromPercentage(
                  Math.min(
                    Number(
                      selectedActivity.value === 'Last 30 days'
                        ? data.percentageDailyTasksCompletionMonth
                        : data.percentageDailyTasksCompletionWeek
                    ),
                    100
                  )
                ) + ' h-[8px] rounded-full'
              ),
                style: _normalizeStyle(
                'width: ' +
                (selectedActivity.value === 'Last 30 days'
                  ? data.percentageDailyTasksCompletionMonth
                  : data.percentageDailyTasksCompletionWeek) +
                '%'
              )
              }, null, 6)
            ]),
            _createElementVNode("span", _hoisted_17, _toDisplayString(selectedActivity.value === "Last 30 days"
                ? data.percentageDailyTasksCompletionMonth
                : data.percentageDailyTasksCompletionWeek) + "% ", 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.page")) + " " + _toDisplayString(currentPageStudents.value) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.of")) + " " + _toDisplayString(totalPages.value), 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: prevPageStudents,
          disabled: currentPageStudents.value === 1,
          class: "text-gray-700 text-sm font-semibold border border-gray-300 px-3 py-2 bg-white rounded-lg disabled:opacity-50 mr-3"
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.previous")), 9, _hoisted_20),
        _createElementVNode("button", {
          onClick: nextPageStudents,
          disabled: currentPageStudents.value === totalPages.value,
          class: "text-gray-700 text-sm font-semibold border border-gray-300 px-3 py-2 bg-white rounded-lg disabled:opacity-50"
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.next")), 9, _hoisted_21)
      ])
    ])
  ]))
}
}

})